import pick from "lodash/pick";

import { getGraphURL } from "../serviceHelper";
import { Page, RequestType } from "../../constants";
import { DateHelper, StringHelper } from "../../helper";
import { GraphRequestBaseService } from "../GraphRequestBase.service";

const fields = [
  "Title",
  "eMonth",
  "eDepartment",
  "eRequestStatus",
  "eRequestType",
  "eComments",
  "eTrainingCourses",
  "eApprovalProcess",
];

const BASE_URL = getGraphURL(Page.monthlyTrainingPlan);
export class HOTrainingCourseMonthlyRequestService extends GraphRequestBaseService {
  constructor(public baseURL: string, public fields: string[]) {
    super(baseURL, fields);
  }

  toRequest(values: any = {}) {
    const request = pick(values, fields);

    if (values?.eApprovalProcess) {
      request["eApprovalProcess"] = JSON.stringify(values?.eApprovalProcess);
    }
    if (values?.eTrainingCourses) {
      const mappedTrainingCourses = values?.eTrainingCourses.map((e: any) => {
        const eDateTime = DateHelper.formatRangeDateToISOStr(e.eDateTime);
        return { ...e, eDateTime };
      });
      const eTrainingCourses = JSON.stringify(mappedTrainingCourses);
      request["eTrainingCourses"] = eTrainingCourses;
    }
    return {
      Title: "Kế hoạch đào tạo tháng",
      eRequestType: RequestType.confirm,
      ...request,
    };
  }
  toResponse(response: any = {}) {
    const eTrainingCourses = StringHelper.parseJSON(
      response?.fields?.eTrainingCourses,
      []
    );
    const mappedETrainingCourses = eTrainingCourses.map((e: any) => ({
      ...e,
      eDateTime: DateHelper.formatRangeDateToMoment(e.eDateTime),
    }));

    return {
      ...response?.fields,
      id: response.id,
      eCreatedBy: `${response.createdBy.user.email}|${response.createdBy.user.displayName}`,
      createdDateTime: response.createdDateTime,
      eTrainingCourses: mappedETrainingCourses,
      eMonth: DateHelper.formatDateToMoment(response?.fields.eMonth),
      eComments: StringHelper.parseJSON(response?.fields?.eComments, []),
      eApprovalProcess: StringHelper.parseJSON(
        response?.fields?.eApprovalProcess,
        []
      ),
    };
  }
}

export const trainingMonthlyPlanApi = new HOTrainingCourseMonthlyRequestService(
  BASE_URL,
  fields
);
